import axios from "axios";

export const cancelInvite = async (data) => {
    let {user_id, role, activeTab} = data
    let res = await axios.delete(`/userManagement/users/${user_id}/?role=${role}&activeTab=${activeTab}`);
    return res.data;
}

export const resendInvite = async (data) => {
    let {user_id, role, activeTab} = data
    let res = await axios.post(`/userManagement/users/${user_id}/invite?role=${role}&activeTab=${activeTab}`);
    return res.data;
}